export default "__VITE_ASSET__CTRiaG4q__"